import { Product } from "./shop.product.model";

export class Bundle {
    /**
     * internal id of the bundle
     */
    id: number;

    /**
     * name of the bundle
     */
    name: string;

    /**
     * flag if the bundle is active
     */
    is_active: boolean;

    /**
     * description of the bundle
     */
    description: string;

    /**
     * creation date of the bundle
     */
    created_at: string;

    /**
     * last update of the bundle
     */
    updated_at: string;

    /**
     * one or more images for the details view of a bundle
     */
    images: { id: number, file: string, forgift: boolean }[];

    /**
     * organisation id of the bundle
     */
    organisation_id: number;

    /**
     * products in the bundle
     */
    bundle_products: { id: number, count: number, product?: Product }[];

    /**
     * text for the details page.
     */
    text: string;

    /**
     * type of the bundle
     */
    type: string;

    /**
     * sort of the bundle
     */
    sort: number;

    /**
     * total price of the bundle
     * this is calculated when the bundle products are loaded
     */
    price: number | null = null;

    /**
     * stock of the bundle
     * this is calculated when the bundle products are loaded
     */
    count: number = 0;

    /**
     * the bundle is always purchasable as long as the products in it are
     * this is calculated when the bundle products are loaded
     */
    isPurchasable: boolean = true;

    /**
     * categories of the products in this bundle
     * this is calculated when the bundle products are loaded
     */
    categories: number[] = [];

    /**
     * available count of the bundle
     * this is calculated when the bundle products are loaded
     */
    availableCount: number;
}